<template>
	<v-snackbar
		bottom
		:color="Notify.snackbar.color"
		:timeout="Notify.snackbar.timeout"
		v-model="snackbar">
		{{ Notify.snackbar.text }}
		<template v-slot:action="{ }">
			<v-btn
				text
				@click="snackbar = false">
				Close
			</v-btn>
		</template>
	</v-snackbar>
</template>

<script>
import Notify from '../../services/notify'

export default {
	name: 'Snackbar',
	data() {
		return {
			Notify,
			snackbar: null
		}
	},
	watch: {
		'Notify.snackbar': function() {
			this.snackbar = true;
		}
	}
}
</script>